import { Box } from '@mui/material'
import React, { FunctionComponent } from 'react'
import { BaseProps } from '../../types'

export const PageDivider: FunctionComponent<BaseProps> = ({ sx = { } }) => <Box sx={{ width: '2px', backgroundColor: '#0003', ...sx}}></Box>